import { Icon } from '@billy/design-system'
import React, { forwardRef, ReactElement, ReactNode } from 'react'
import { DraggableProvidedDraggableProps, DraggableProvidedDragHandleProps } from 'react-beautiful-dnd'

import * as Styled from './styles'

interface DraggableItemProps extends DraggableProvidedDraggableProps {
  children: ReactNode
  dragHandleProps?: DraggableProvidedDragHandleProps | null
  isDragging: boolean
  isDraggable: boolean
  showDragZoneOnlyOnHover?: boolean
}

export const DraggableItem = forwardRef<HTMLDivElement, DraggableItemProps>(
  (
    { children, isDraggable, isDragging, dragHandleProps, showDragZoneOnlyOnHover, ...rest }: DraggableItemProps,
    forwardedRef,
  ): ReactElement => (
    <Styled.DraggableItemWrapper {...rest} dragging={isDragging} ref={forwardedRef}>
      {isDraggable && (
        <Styled.DragZone {...dragHandleProps} showOnHover={showDragZoneOnlyOnHover}>
          <Icon icon="gripVertical" />
        </Styled.DragZone>
      )}
      {children}
    </Styled.DraggableItemWrapper>
  ),
)
